import { render, staticRenderFns } from "./postingamortisasi.vue?vue&type=template&id=6c4252f8&scoped=true&"
import script from "./postingamortisasi.vue?vue&type=script&lang=js&"
export * from "./postingamortisasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4252f8",
  null
  
)

export default component.exports